// @flow
import React from 'react'
import styled, { type StyledComponent } from 'styled-components'
import { ClearFix } from '../controls'
import type { Image, Crop } from '../../types'
import OptionalResponsibleImage from './OptionalResponsibleImage'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  padding: 10px 20px;
  border: 1px solid #cecece;
  background: #fff;
  float: left;
  word-wrap: break-word;
`
const Title: StyledComponent<Object, any, any> = styled.div`
  border-collapse: collapse;
  border: 0 none rgb(66, 100, 139);
  color: rgb(66, 100, 139);
  column-rule-color: rgb(66, 100, 139);
  display: block;
  font-family: -apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 15px;
  outline: rgb(66, 100, 139) none 0;
  perspective-origin: 72.5px 15px;
  transform-origin: 72.5px 15px;
  width: 145px;
`
const Url: StyledComponent<Object, any, any> = styled.div`
  border-collapse: collapse;
  border: 0 none rgb(147, 150, 153);
  color: rgb(147, 150, 153);
  column-rule-color: rgb(147, 150, 153);
  display: block;
  font-family: -apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 12px;
  line-height: 15px;
  height: 15px;
  outline: rgb(147, 150, 153) none 0;
  overflow-wrap: break-word;
  padding: 4px 0 0;
  perspective-origin: 72.5px 8px;
  transform-origin: 72.5px 8px;
  width: 145px;
  word-wrap: break-word;
`
const Text: StyledComponent<Object, any, any> = styled.div`
  border-collapse: collapse;
  display: block;
  font-family: -apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 12px;
  padding: 8px 0 0;
  perspective-origin: 72.5px 31.5px;
  transform-origin: 72.5px 31.5px;
  width: 145px;
`

type Props = {|
  title: string,
  description: string,
  url: string,
  image: ?Image,
  imageCrop: ?Crop
|}

export default function VkPreview(props: Props) {
  const { url, title, description, image, imageCrop } = props

  return (
    <Wrapper>
      <ClearFix>
        <OptionalResponsibleImage image={image} imageCrop={imageCrop} width={145} ratio={1.71} />
      </ClearFix>
      <Title>{title}</Title>
      <Url>{url}</Url>
      <Text>{description}</Text>
    </Wrapper>
  )
}
